/**
 * Publishing rewrites CDN image URLs to site-relative paths, but the published domain does not
 * serve /ai/img_res/sandbox/* (it returns the HTML fallback). Point those paths back at the CDN.
 * The host is assembled at runtime so the publish step cannot rewrite it again.
 * Full URLs (editor / share preview) pass through unchanged.
 */
const CDN_ORIGIN = ['https:', '', ['public', 'readdy', 'ai'].join('.')].join('/');

export const cdn = (u: string): string => (u.startsWith('/ai/img_res/sandbox/') ? `${CDN_ORIGIN}${u}` : u);